interface EnvironmentConfig {
  apiBaseUrl: string;
  auth0Domain: string;
  auth0ClientId: string;
  auth0Audience: string;
  defaultClientId?: string;
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  // Get environment variables
  const envVars = {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    auth0Domain: process.env.REACT_APP_AUTH0_DOMAIN,
    auth0ClientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    auth0Audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    defaultClientId: process.env.REACT_APP_DEFAULT_CLIENT_ID,
  };

  // Check for missing Auth0 configuration (required for authentication)
  const missingAuth0Vars = Object.entries(envVars)
    .filter(([key, value]) => key.startsWith('auth0') && !value)
    .map(([key]) => key);

  if (missingAuth0Vars.length > 0) {
    console.error(`Missing required Auth0 environment variables: ${missingAuth0Vars.join(', ')}`);
    console.error('Please check your .env file and ensure all Auth0 variables are set.');
  }

  // Check for missing API base URL
  if (!envVars.apiBaseUrl) {
    console.warn('Missing REACT_APP_API_BASE_URL, using default: http://localhost:3001/api');
  }

  return {
    apiBaseUrl: envVars.apiBaseUrl || 'http://localhost:3001/api',
    auth0Domain: envVars.auth0Domain || '',
    auth0ClientId: envVars.auth0ClientId || '',
    auth0Audience: envVars.auth0Audience || '',
    defaultClientId: envVars.defaultClientId || '',
  };
};

export const config = getEnvironmentConfig();

// Export individual config values for convenience
export const { apiBaseUrl, auth0Domain, auth0ClientId, auth0Audience, defaultClientId } = config; 